import links from "../partials/links";

const column = (name, label) => ({
  label,
  name,
  widget: "object",
  collapsed: true,
  fields: [
    {
      label: "Title",
      name: "title",
      widget: "string",
      required: true,
    },
    links("Links", "links"),
  ],
});

export default column;
